<template>
  <gg-card>
    <gg-card-header>
      <v-row>
        <v-col md="6">
          Accounts List
          <gg-btn secondary class="ml-2 mb-1" @click="$router.push(addAccountPath)">
            Add Account
          </gg-btn>
        </v-col>
        <v-col md="6" class="text-right">
          <span class="font-sm">
            <router-link v-if="short" :to="listAccountsPath">View All Accounts →</router-link>
          </span>
          <gg-btn class="mr-2" secondary @click="launch_whm($route.params.hostingid)">
            WHM Access
            <v-icon small class="pl-2">
              mdi-open-in-new
            </v-icon>
          </gg-btn>
        </v-col>
      </v-row>
    </gg-card-header>

    <gg-card-text>
      <table-wrapper>
      <v-data-table
        style=""
        id="my-table"
        :items="items"
                    :loading="isLoading"
                    :headers="tableHeaders"
      >
        <template v-slot:item="{ item, isMobile, headers }">
          <tr v-if="isMobile" :style="{ backgroundColor: item.suspended ? ' #FFB8B8': ''}" class="v-data-table__mobile-table-row">
            <td class="v-data-table__mobile-row" :key="`header-${header.value}`" v-for="header in headers">
              <div class="v-data-table__mobile-row__header">{{ header.text }}</div>
              <div v-if="header.value === 'plan'" class="v-data-table__mobile-row__cell">
                {{ textTruncate(formatPackageNameForTable(item.plan), 16) }}
                <v-icon small class="ml-1 mb-1" color="primary" @click="openPlanModal(item)">
                  mdi-pencil
                </v-icon>
              </div>
              <div v-else-if="header.value === 'actions'" class="v-data-table__mobile-row__cell">
                <div v-if="!item.suspended" class="text-right">
                  <gg-btn :disabled="!!item.suspended" class="mr-2" :to="{ path: `/hosting/shared/${hosting.id}`, query: { user: item.user } }">
                    Manage
                  </gg-btn>
                  <template v-if="!short">
                    <gg-btn class="mr-2 text-none" tile secondary @click="launch_cpanel($route.params.hostingid, item.user)">
                      cPanel
                      <v-icon small class="pl-2">
                        mdi-open-in-new
                      </v-icon>
                    </gg-btn>
                  </template>
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <gg-btn color="primary" icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </gg-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="openChangePasswordModal(item)">
                        <v-list-item-title>
                          <v-icon small class="pb-1">mdi-lock</v-icon>
                          Password Management
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item :disabled="item.isMain" @click="openSuspendModal(item.user, item.suspended)">
                        <v-list-item-title>
                          <v-icon small class="pb-1">mdi-cancel</v-icon>
                          <span v-if="item.suspended">
                            Unsuspend Account
                          </span>
                          <span v-else>
                            Suspend Account
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item :disabled="item.isMain" @click="openDeleteModal(item.user)">
                        <v-list-item-title>
                          <v-icon small class="pb-1">mdi-trash-can-outline</v-icon>
                          Delete Account
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div v-else class="text-right">
                  <gg-btn secondary class="mr-2" @click="openSuspendModal(item.user, item.suspended)">
                    Unsuspend
                  </gg-btn>
                </div>
              </div>
              <div v-else class="v-data-table__mobile-row__cell">{{ item[header.value] }}</div>
            </td>
          </tr>
          <tr v-else :style="{ backgroundColor: item.suspended ? ' #FFB8B8': ''}">
            <td>
              {{ item.user }}
            </td>
            <td>
              {{ item.domain }}
            </td>
            <td>
              {{ item.ip }}
            </td>
            <td>
              {{ item.quota }}
            </td>
            <td>
              {{ item.diskUsed }}
            </td>
            <td>
              <div>
                {{ textTruncate(formatPackageNameForTable(item.plan), 16) }}
                <v-icon small class="ml-1 mb-1" color="primary" @click="openPlanModal(item)">
                  mdi-pencil
                </v-icon>
              </div>
            </td>
            <td>
              <div v-if="!item.suspended" class="text-right">
                <gg-btn :disabled="!!item.suspended" class="mr-2" :to="{ path: `/hosting/shared/${hosting.id}`, query: { user: item.user } }">
                  Manage
                </gg-btn>
                <template v-if="!short">
                  <gg-btn class="mr-2 text-none" tile secondary @click="launch_cpanel($route.params.hostingid, item.user)">
                    cPanel
                    <v-icon small class="pl-2">
                      mdi-open-in-new
                    </v-icon>
                  </gg-btn>
                </template>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <gg-btn color="primary" icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </gg-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openChangePasswordModal(item)">
                      <v-list-item-title>
                        <v-icon small class="pb-1">mdi-lock</v-icon>
                        Password Management
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="item.isMain" @click="openSuspendModal(item.user, item.suspended)">
                      <v-list-item-title>
                        <v-icon small class="pb-1">mdi-cancel</v-icon>
                        <span v-if="item.suspended">
                          Unsuspend Account
                        </span>
                        <span v-else>
                          Suspend Account
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="item.isMain" @click="openDeleteModal(item.user)">
                      <v-list-item-title>
                        <v-icon small class="pb-1">mdi-trash-can-outline</v-icon>
                        Delete Account
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div v-else class="text-left">
                <gg-btn secondary class="mr-2" @click="openSuspendModal(item.user, item.suspended)">
                  Unsuspend
                </gg-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      </table-wrapper>
    </gg-card-text>

    <confirmation-modal v-model="deleteModal.show"
                        :loading="deleteModal.loading"
                        @cancel="closeDeleteModal"
                        @confirm="deleteSubAccount">
      <p>Do you really want to delete "{{ deleteModal.username }}" account?</p>
      <p>All data will be lost and cannot be recovered.</p>
    </confirmation-modal>

    <confirmation-modal v-model="suspendModal.show"
                        :loading="suspendModal.loading"
                        @cancel="closeSuspendModal"
                        @confirm="switchSubAccountStatus">
      <p>
        Do you really want to {{ suspendModal.suspended ? 'unsuspend' : 'suspend' }} "{{ suspendModal.username }}" account?
      </p>
    </confirmation-modal>
    <gg-modal :is-active="modalUpdateEmail" @close="closeUpdateEmailModal">
      <template v-slot:toolbar>
        Update Email
      </template>
      <template v-slot:body>
        <v-text-field
          :label="`E-mail for ${user}`"
          outlined
          v-model.trim="email"
          data-vv-name="email"
          data-vv-as="Email"
          v-validate="modalUpdateEmail ? 'required|email': ''"
          :disabled="isUpdatingEmail"
          :error-messages="errors.collect('email')">
        </v-text-field>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeUpdateEmailModal">
          Cancel
        </gg-btn>
        <gg-btn primary @click="updateContactEmail" :loading="isUpdatingEmail">
          Update
        </gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="modalUpdatePlan" @close="closePlanModal">
      <template v-slot:toolbar>
        Update Plan
      </template>
      <template v-slot:body>
        <gg-select
          outlined
          :label="`Plan for ${user}`"
          v-model="plan"
          :items="planOptions"
        ></gg-select>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closePlanModal">
          Cancel
        </gg-btn>
        <gg-btn primary @click="updatePlan" :loading="isUpdatingPlan">
          Update
        </gg-btn>
      </template>
    </gg-modal>
    <gg-modal :is-active="modalChangePassword" @close="closeChangePasswordModal">
      <template v-slot:toolbar>
        Change Password
      </template>
      <template v-slot:body>
        <compact-password
          outlined
          cpanel-app="passwd"
          v-model="password"
          :label="`New Password for ${user}`"
          show-strength
          with-generator
          charset="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_"
          autocomplete="new-password"
          v-validate="modalChangePassword ? 'required|min:8' : ''"
          data-vv-name="password"
          data-vv-as="Password"
          :error-messages="errors.collect('password')"
        />
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeChangePasswordModal">
          Cancel
        </gg-btn>
        <gg-btn primary @click="updatePassword" :loading="isUpdatingPassword">
          Change
        </gg-btn>
      </template>
    </gg-modal>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfirmationModal from '@/components/Common/ConfirmationModal'
import CompactPassword from '@/components/Common/password/CompactPassword'
import { humanFileSize, stringIntToBytes, launch_cpanel, launch_whm, textTruncate } from '@/helpers/helpers'
import { RESELLER_SERVICE_PRIVILEGE_PACKAGE_ADD } from '@/consts/service'
import TableWrapper from '@/components/Common/TableWrapper.vue'

export default {
  name: 'ResellerAccountsList',
  components: {
    ConfirmationModal,
    CompactPassword,
    TableWrapper,
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    short: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Username',
          value: 'user',
        },
        {
          text: 'Domain',
          value: 'domain',
        },
        {
          text: 'IP Address',
          value: 'ip',
        },
        {
          text: 'Quota',
          value: 'quota',
        },
        {
          text: 'Disk Used',
          value: 'diskUsed',
        },
        {
          text: 'Package',
          value: 'plan',
        },
        {
          text: 'Actions',
          value: 'actions',
          width: '10%'
        },
      ],
      shortHeaderValues: ['user', 'domain', 'actions', 'manage'],
      loadingSubaccounts: false,
      deleteModal: {
        show: false,
        username: null,
        loading: false,
      },
      suspendModal: {
        show: false,
        username: null,
        suspended: false, // true - Unsuspend, false - Suspend
        loading: false,
      },
      modalUpdateEmail: false,
      modalUpdatePlan: false,
      modalChangePassword: false,
      user: '',
      email: '',
      plan: '',
      password: '',
      isUpdatingEmail: false,
      isUpdatingPlan: false,
      isUpdatingPassword: false,
    }
  },
  computed: {
    ...mapGetters([
      'hosting_detail',
      'hosting',
      'hostingPopulated',
      'hosting_error',
      'getResellerPackages',
      'getResellerPrivileges',
    ]),
    isLoading () {
      return this.loading || this.loadingSubaccounts
    },
    hostingid () {
      return this.hosting.id
    },
    listAccountsPath () {
      return `/hosting/reseller/${this.hostingid}/list-accounts`
    },
    addAccountPath () {
      return `/hosting/reseller/${this.hostingid}/accounts/add`
    },
    items () {
      const accounts = this.hosting_detail.accounts || []
      if (!this.short) {
        accounts.forEach((acc) => {
          acc.diskUsed = humanFileSize(stringIntToBytes(acc.diskused))
          acc.quota = acc.disklimit === 'unlimited' ? 'Unlimited' : humanFileSize(stringIntToBytes(acc.disklimit))
        })
      }
      return this.decorateAccountsWithMainAccounts(accounts)
    },
    tableHeaders () {
      if (this.short) {
        return this.headers.filter((header) => {
          return this.shortHeaderValues.includes(header.value)
        })
      } else {
        return this.headers
      }
    },
    planOptions () {
      return this.getResellerPackages.map((item) => item.name)
    },
    packagePrefix () {
      return `${this.hosting_detail.user}_`
    },
    featureListingAllowed () {
      return !!this.getResellerPrivileges[RESELLER_SERVICE_PRIVILEGE_PACKAGE_ADD]
    },
  },
  methods: {
    ...mapActions(['suspendSubAccount', 'unsuspendSubAccount', 'removeSubAccount', 'getHostingDetail', 'updateSettings', 'fetchResellerPackages', 'changeAccountHostingPlan', 'setHostingPassword', 'reportError', 'reportSuccess']),
    launch_cpanel,
    launch_whm,
    textTruncate,
    openDeleteModal (username) {
      this.deleteModal.show = true
      this.deleteModal.username = username
    },
    closeDeleteModal () {
      this.deleteModal.show = false
      this.deleteModal.username = null
      this.deleteModal.loading = false
    },
    openSuspendModal (username, suspended) {
      this.suspendModal.show = true
      this.suspendModal.username = username
      this.suspendModal.suspended = suspended
    },
    closeSuspendModal () {
      this.suspendModal.show = false
      this.suspendModal.username = null
      this.suspendModal.suspended = false // reset to default
      this.suspendModal.loading = false
    },
    async switchSubAccountStatus () {
      this.loadingSubaccounts = true
      this.suspendModal.loading = true
      if (this.suspendModal.suspended) {
        await this.unsuspendSubAccount(this.suspendModal.username)
      } else {
        await this.suspendSubAccount(this.suspendModal.username)
      }
      this.closeSuspendModal()
      await this.getHostingDetail()
      this.loadingSubaccounts = false
    },
    async deleteSubAccount () {
      this.loadingSubaccounts = true
      this.deleteModal.loading = true
      await this.removeSubAccount(this.deleteModal.username)
      this.closeDeleteModal()
      await this.getHostingDetail()
      this.loadingSubaccounts = false
    },
    decorateAccountsWithMainAccounts (accounts = []) {
      const main = {
        user: this.hosting_detail.user,
        domain: this.hosting.domain,
        ip: this.hosting_detail.ip,
        plan: '',
        diskUsed: humanFileSize(this.hosting_detail.disk_used),
        quota: humanFileSize(this.hosting_detail.disk_limit),
        isMain: true,
      }
      return [main, ...accounts]
    },
    openContactEmailModal ({ user, email }) {
      this.modalUpdateEmail = true
      this.user = user
      this.email = email
    },
    closeUpdateEmailModal () {
      this.modalUpdateEmail = false
    },
    async updateContactEmail () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        return
      }
      this.isUpdatingEmail = true
      const data = {
        contactemail: this.email,
        user: this.user
      }
      await this.updateSettings(data)
      this.isUpdatingEmail = false
      this.modalUpdateEmail = false
      this.reset()
    },
    openPlanModal ({ user, plan }) {
      this.modalUpdatePlan = true
      this.user = user
      this.plan = plan
    },
    closePlanModal () {
      this.modalUpdatePlan = false
    },
    async updatePlan () {
      this.isUpdatingPlan = true
      const data = {
        pkg: this.plan,
        user: this.user
      }
      await this.changeAccountHostingPlan(data)
      this.isUpdatingPlan = false
      this.modalUpdatePlan = false
    },
    openChangePasswordModal ({ user }) {
      this.modalChangePassword = true
      this.user = user
    },
    closeChangePasswordModal () {
      this.modalChangePassword = false
    },
    reset () {
      this.password = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async updatePassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.isUpdatingPassword = true
      const data = {
        pass: this.password,
        username: this.user,
      }
      try {
        const message = await this.setHostingPassword(data)
        this.reportSuccess(message)
      } catch (e) {
        this.reportError(e)
      }
      this.isUpdatingPassword = false
      this.modalChangePassword = false
      this.reset()
    },
    formatEmailText (userEmail) {
      if (userEmail === '*unknown*' || !userEmail) {
        return 'Not Set'
      }
      return userEmail
    },
    formatPackageNameForTable (fullPackageName) {
      if (!fullPackageName || fullPackageName === 'undefined') {
        return 'No Package Set'
      }
      if (!fullPackageName.includes(this.packagePrefix)) {
        return fullPackageName
      }
      return fullPackageName.substring(this.packagePrefix.length)
    },

  },
  mounted () {
    if (!this.featureListingAllowed) {
      return
    }
    this.fetchResellerPackages()
  }
}
</script>
<style>
th:last-child {
  text-align: center !important;
}
</style>
